import { render, staticRenderFns } from "./control-panel.vue?vue&type=template&id=cc9e1308&scoped=true"
import script from "./control-panel.vue?vue&type=script&lang=ts"
export * from "./control-panel.vue?vue&type=script&lang=ts"
import style0 from "./control-panel.vue?vue&type=style&index=0&id=cc9e1308&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc9e1308",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ControlPanelSidebar: require('/app/components/ControlPanel/Layout/ControlPanelSidebar.vue').default,MobileNav: require('/app/components/Layout/MobileNav.vue').default,ZBreadcrumbItem: require('/app/components/zeal/ZBreadcrumb/ZBreadcrumbItem/ZBreadcrumbItem.vue').default,ZBreadcrumb: require('/app/components/zeal/ZBreadcrumb/ZBreadcrumb.vue').default,ZButton: require('/app/components/zeal/ZButton/ZButton.vue').default,ZTab: require('/app/components/zeal/ZTab/ZTab.vue').default,SidebarItem: require('/app/components/Layout/Sidebar/SidebarItem.vue').default})
